export default {"src":"/_next/static/image/public/images/ic_file_pdf.833888ae6e13e216c20feadfcf1bbb97.svg","height":24,"width":24};